import { format, isValid, parseISO } from 'date-fns';

export const createMessages = (elements = []) => {
  return elements.map(({ id, created, subject, message, wasRead }) => {
    const title = !subject || subject === 'null' ? message : subject;
    const date = isValid(parseISO(created)) ? format(parseISO(created), 'MM-dd-yyyy') : created;

    return { id, title, date, wasRead };
  });
};
